(function() {
'use strict';

angular
    .module('TR')
    .service('trackingPixelsService', trackingPixelsService);

function trackingPixelsService($filter, cookieService, $http) {
    let data = { bookingRef: '', costing: { totalCost: 0, currencyCode: '' }, area: '' };
    const flightBookingPrefix = 'SCH';
    const hotelBookingPrefix = 'ACM';
    const bundleBookingPrefix = 'BND';
    const marhabaBookingPrefix = 'MHB';
    const insuranceBookingPrefix = 'INS';
    const transferBookingPrefix = 'TRN';

    const service = {
        setData,
        report
    };

    function _getBookingId(bookingId) {
        const prefixExp = new RegExp(`(${flightBookingPrefix}|${hotelBookingPrefix}|${bundleBookingPrefix}|${marhabaBookingPrefix}|${insuranceBookingPrefix}|${transferBookingPrefix})/\\d+`, 'g');

        bookingId = bookingId.split('|').find(id => {
            return id.search(prefixExp) >= 0;
        });

        if (bookingId && bookingId.indexOf('/') > -1) {
            bookingId = bookingId.split('/')[1];
        }

        return bookingId || '';
    }


    function report(eventType, source) {
        const provider = _getProvider(source);
        const eventData = {
            VisitSource: source,
            EventType: eventType,
            ClickId: provider.clickId,
            BookingId: parseInt(provider.bookingId)
        };

        $http.post('/api2/b2b/tpe/', eventData);
    }

    function setData(bookingRefs, currencyCode, totalCost, hotel, rooms) {
        if (bookingRefs && totalCost) {
            data = {
                bookingRef: bookingRefs.join('|'),
                costing: { totalCost, currencyCode }
            };
        } else {
            data.bookingRef = '';
        }

        if (hotel) {
            data.hotel = hotel;
        }

        if (rooms) {
            data.rooms = rooms;
        }

        return data;
    }

    function _getProvider(source) {
        let provider = {
            name: 'unknown',
            source: source || 'unknown',
            bookingId: _getBookingId(data.bookingRef),
            clickId: ''
        };

        return provider;
    }

    return service;
}
})();
